/**
 * DisplayProbe — reports the screen m3cull is running on. Nothing else.
 */

import { previewTargetPx } from '../domain/preview-size';
import type { DisplayInfo } from '../types';

export class DisplayProbe {
  read(): DisplayInfo {
    const longEdgePx = Math.max(window.screen.width, window.screen.height);
    const scaleFactor = window.devicePixelRatio || 1;

    return {
      longEdgePx,
      scaleFactor,
      realLongEdgePx: Math.round(longEdgePx * scaleFactor),
      previewTargetPx: previewTargetPx(longEdgePx, scaleFactor),
    };
  }
}
